import React, { Component } from "react";
import CmModal from "../../../../components/CmModal/CmModal";
import CmForm from "../../../../components/CmForm/CmForm";
import { Form, Input } from "antd";
import { message } from "../../utils/sysManagementUtils";
import ConfigTreeSelect from "../configTreeSelect/ConfigTreeSelect";
import { validateName } from "../../../../utils";

const FormItem = Form.Item;

export default class ConfigTreeEditModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editData: null
        };
    }

    componentDidUpdate = (prevProps, prevState, snapshot) => {
        if (this.props.visible && this.props.visible !== prevProps.visible) {
            this.setState({
                editData: this.initData(this.props.data || {})
            });
        }
    };

    render() {
        const {
            visible
        } = this.props;

        const { editData } = this.state;

        if (!editData) {
            return null;
        }

        const isCreate = !editData.id.value;
        const onDataChange = this.onDataChange;

        return (
            <CmModal
                title={isCreate ? "添加栏目" : "修改栏目"}
                visible={visible}
                handleCancel={this.handleCancel}
                handleOk={this.handleOk}
            >
                <CmForm>
                    {
                        isCreate ? <FormItem
                            required={editData.fid.required}
                            label={editData.fid.label}
                        >
                            <ConfigTreeSelect
                                value={editData.fid.value}
                                onChange={fid => onDataChange({ fid })}
                                checkStrictly={true}
                                onItemDelete={id => onDataChange({ fid: "" })}
                                placeholder={editData.fid.placeholder}
                            />
                        </FormItem> : null
                    }
                    <FormItem
                        required={editData.name.required}
                        label={editData.name.label}
                    >
                        <Input
                            placeholder={editData.name.placeholder}
                            value={editData.name.value}
                            onChange={e => onDataChange({ name: e.target.value })}
                        />
                    </FormItem>
                </CmForm>
                <style>{`
                .ant-modal-body .ant-form .ant-form-item:nth-last-child(2) {
                    margin-bottom: 0px !important;
                 }
                `}</style>
            </CmModal>
        );
    }

    onDataChange = data => {
        const editData = this.state.editData;
        Object.keys(data).forEach(key => {
            editData[key].value = data[key];
        });
        this.setState({});
    };

    handleOk = () => {
        const { editData } = this.state;
        const data = {};
        const editDataKeys = Object.keys(editData);
        for (let i = 0; i < editDataKeys.length; i++) {
            const key = editDataKeys[i];
            data[key] = editData[key].value;
            if (editData[key].check && !editData[key].check(editData[key].value)) {
                return;
            }
        }
        this.props.handleOk(data);
    };

    handleCancel = () => {
        this.props.handleCancel();
    };

    initData = (
        {
            fid = "",
            name = "",
            id = ""
        } = {}
    ) => {
        const editData = {
            id: {
                value: id
            },
            fid: {
                value: fid,
                label: "上级栏目",
                required: true,
                placeholder: "请选择上级栏目",
                check: value => {
                    let check = true;
                    if (!value) {
                        check = false;
                        message.error("请选择上级栏目");
                    }
                    return check;
                }
            },
            name: {
                value: name,
                label: "栏目名称",
                required: true,
                placeholder: "请输入栏目名称",
                check: value => {
                    let check = true;
                    if (!validateName(value, { min: 2, max: 18 })) {
                        message.error("栏目名称为2-18个字，可使用中文、数字、字母、下划线");
                        check = false;
                    }
                    if (!value) {
                        message.error("栏目名称不能为空");
                        check = false;
                    }
                    return check;
                }
            }
        };
        return editData;
    };
}

